// eslint-disable-next-line import/no-anonymous-default-export
export default {
    GLOBAL_FILTER_SN_SET: 'GLOBAL_FILTER_SN_SET'
}